module.exports = __webpack_public_path__ + "img/customer-service.eb92c891.png";